<template>
  <div class="id-photo-editor">
    <!-- 广告位 -->
    <ad-top></ad-top>
    <!-- 简介 -->
    <el-row type="flex" justify="center">
      <el-col :md="20">
        <div class="intro-detail">
          {{ $t('tools.idPhotoEditor.introduction') }}
          <el-link type="primary" href target="_blank">Learn more!</el-link>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :md="{span: 10, offset: 2}">
        <div v-show="data.loaded">
          <img
            id="id-photo-img"
            ref="idPhotoImg"
            :alt="data.name"
            :src="data.url"
            @ready="getCropBoxData"
            @cropmove="getCropBoxData"
          />
        </div>
        <div v-show="!data.loaded">
          <img-loader :data="data"></img-loader>
        </div>
      </el-col>
      <!-- 配置区 -->
      <el-col :md="12">
        <!-- 裁剪框模式 -->
        <el-row>
          <el-col
            :md="{span: 12, offset: 6}"
            :sm="{span: 18, offset: 4}"
            :xs="{span: 18, offset: 4}"
          >
            <el-radio-group
              v-model="config.cropBoxMode"
              class="config-item first"
              @change="setCropBoxMode"
            >
              <el-radio-button :label="0">{{ $t('tools.idPhotoEditor.customize') }}</el-radio-button>
              <el-radio-button :label="1">{{ $t('tools.idPhotoEditor.standard') }}</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
        <!-- 裁剪框标准宽高 -->
        <el-row>
          <el-col
            :md="{span: 12, offset: 6}"
            :sm="{span: 18, offset: 4}"
            :xs="{span: 18, offset: 4}"
          >
            <el-select
              v-model="config.cropBoxType"
              filterable
              class="config-item"
              @change="setCropBoxType"
              :disabled="config.cropDataSelectDisabled"
            >
              <el-option
                v-for="item in standards"
                :key="item.key"
                :label="item.data.label"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <!-- 宽度配置 -->
        <el-row>
          <el-col
            :md="{span: 12, offset: 6}"
            :sm="{span: 18, offset: 4}"
            :xs="{span: 18, offset: 4}"
          >
            <el-input
              v-model.number="cropWidth"
              class="config-item"
              @change="setCropBoxData"
              :disabled="config.cropDataInputDisabled"
            >
              <template slot="prepend">{{ $t('tools.idPhotoEditor.width') }}</template>
              <el-select v-model="unitSelect" slot="append" class="unit-select">
                <el-option label="px" value="px"></el-option>
                <el-option label="mm" value="mm"></el-option>
              </el-select>
            </el-input>
          </el-col>
        </el-row>
        <!-- 高度配置 -->
        <el-row>
          <el-col
            :md="{span: 12, offset: 6}"
            :sm="{span: 18, offset: 4}"
            :xs="{span: 18, offset: 4}"
          >
            <el-input
              v-model.number="cropHeight"
              class="config-item"
              @change="setCropBoxData"
              :disabled="config.cropDataInputDisabled"
            >
              <template slot="prepend">{{ $t('tools.idPhotoEditor.height') }}</template>
              <el-select v-model="unitSelect" slot="append" class="unit-select">
                <el-option label="px" value="px"></el-option>
                <el-option label="mm" value="mm"></el-option>
              </el-select>
            </el-input>
          </el-col>
        </el-row>
        <!-- 旋转配置 -->
        <el-row>
          <el-col
            :md="{span: 12, offset: 6}"
            :sm="{span: 18, offset: 4}"
            :xs="{span: 18, offset: 4}"
          >
            <el-button-group class="config-item short">
              <el-button type="primary" icon="el-icon-refresh-left" @click="rotateImg('left')"></el-button>
              <el-button type="primary" icon="el-icon-refresh-right" @click="rotateImg('right')"></el-button>
              <el-input v-model.number="config.degree">
                <template slot="append">°</template>
              </el-input>
            </el-button-group>
          </el-col>
        </el-row>
        <!-- 保存格式 -->
        <el-row>
          <el-col
            :md="{span: 12, offset: 6}"
            :sm="{span: 18, offset: 4}"
            :xs="{span: 18, offset: 4}"
          >
            <el-select class="config-item" v-model="config.saveType.type" @change="changeSaveTypes">
              <el-option
                v-for="item in saveTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <!-- 导入图片 -->
        <el-row>
          <el-col
            :md="{span: 12, offset: 6}"
            :sm="{span: 18, offset: 4}"
            :xs="{span: 18, offset: 4}"
          >
            <el-button-group class="config-item config-big-btn">
              <el-button class="config-big-child-btn" type="primary" icon="el-icon-upload" @click="importImg" round>
                {{ $t('tools.idPhotoEditor.importImg') }}
              </el-button>
              <el-button class="config-big-child-btn" type="primary" icon="el-icon-refresh" @click="resetEditor" round>
                {{ $t('tools.idPhotoEditor.reset') }}
              </el-button>
            </el-button-group>
          </el-col>
        </el-row>
        <!-- 裁剪图片 -->
        <el-row>
          <el-col
            :md="{span: 12, offset: 6}"
            :sm="{span: 18, offset: 4}"
            :xs="{span: 18, offset: 4}"
          >
            <el-button
              class="config-item config-big-btn"
              type="primary"
              icon="el-icon-scissors"
              @click="cropAndSave"
              round
            >{{ $t('tools.idPhotoEditor.cropImg') }}</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 广告位 -->
    <ad-bottom></ad-bottom>
  </div>
</template>

<script>
import adTop from "../../components/ad/ad-top";
import adBottom from "../../components/ad/ad-bottom";
import imgLoader from "../../components/img-loader";
import { standards } from "../../libs/data/id-photo-standards"
import { saveAs } from "file-saver";
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import pxConvertor from '../../utils/px-convert';

export default {
  name: "id-photo-editor",
  data() {
    return {
      cropper: new Object(),
      options: {
        viewMode: 1,
        initialAspectRatio: 6 / 9
      },
      data: {
        loaded: false,
        name: "",
        type: "",
        url: ""
      },
      config: {
        cropBoxMode: 0,
        cropBoxType: 0,
        cropBoxTypeData: {},
        width: 0,
        height: 0,
        degree: 90,
        saveType: {
          type: "image/png",
          suffix: "png"
        },
        cropDataInputDisabled: false,
        cropDataSelectDisabled: true,
        scale: {
          isScaled: false,
          value: 1
        }
      },
      saveTypes: [
        {
          label: "PNG",
          value: "image/png"
        },
        {
          label: "JPG",
          value: "image/jpeg"
        },
        {
          label: "GIF",
          value: "image/gif"
        }
      ],
      standards: standards,
      unitSelect: 'px',
      cropWidth: 0,
      cropHeight: 0
    };
  },
  components: {
    adTop,
    adBottom,
    imgLoader
  },
  watch: {
    "data.url": {
      handler: function() {
        // 不应该使用箭头函数来定义 watcher 函数
        // 箭头函数绑定了父级作用域的上下文，所以 this 将不会按照期望指向 Vue 实例
        this.cropper.replace(this.data.url);
        // 设置自定义宽高为初始化宽高
        this.getCropBoxData();
      },
      // 深度观察
      deep: true
    },
    cropWidth(value) {
      if(this.unitSelect === 'mm'){
        this.config.width = pxConvertor.mmToPx(value)
      } else {
        this.config.width = value;
      }
    },
    cropHeight(value) {
      if(this.unitSelect === 'mm'){
        this.config.height = pxConvertor.mmToPx(value)
      } else {
        this.config.height = value;
      }
    }
  },
  methods: {
    initCropper() {
      const cropper = new Cropper(this.$refs.idPhotoImg, this.options);
      this.$refs.idPhotoImg.addEventListener('zoom',  (event) => {
        console.log(event.detail.ratio)
        console.log(event.detail.oldRatio)
        //TODO: 添加缩放后像素对应变化设置，使得在缩放后裁剪尺寸正确
        // Zoom in
        if (event.detail.ratio > event.detail.oldRatio) {
         // event.preventDefault(); // Prevent zoom in
        }

        // Zoom out
        // ...
        let imgData = this.cropper.getImageData();
        console.log(imgData)
        // this.cropper.scale(event.detail.ratio / event.detail.oldRatio);
      });
      this.cropper = cropper;
    },
    setCropBoxMode() {
      const mode = this.config.cropBoxMode;
      if (mode === 0) {
        // 自定义模式
        // 设置裁剪框可拉伸收缩
        this.options.cropBoxResizable = true;
        let exportCropBoxData = this.cropper.getCropBoxData();
        let exportCanvasData = this.cropper.getCanvasData();
        this.options.ready = function () {
          this.cropper.setCropBoxData(exportCropBoxData).setCanvasData(exportCanvasData);
        };
        // Restart
        this.cropper.destroy();
        this.cropper = new Cropper(this.$refs.idPhotoImg, this.options);
        this.cropper.replace(this.data.url);

        // 设置下拉框禁用
        this.config.cropDataSelectDisabled = true;
        this.config.cropDataInputDisabled = false;
      } else if (mode === 1) {
        // 标准模式
        // 设置裁剪框宽高
        this.setCropBoxType(this.config.cropBoxType);
        // 取消裁剪框可拉伸收缩
        this.options.cropBoxResizable = false;
        let exportCropBoxData = this.cropper.getCropBoxData();
        let exportCanvasData = this.cropper.getCanvasData();
        this.options.ready = function () {
          this.cropper.setCropBoxData(exportCropBoxData).setCanvasData(exportCanvasData);
          this.cropper.setDragMode('move')
        };
        
        // Restart
        this.cropper.destroy();
        this.cropper = new Cropper(this.$refs.idPhotoImg, this.options);
        this.cropper.replace(this.data.url);
        
        
        // 设置下拉框禁用
        this.config.cropDataSelectDisabled = false;
        this.config.cropDataInputDisabled = true;
      }
    },
    setCropBoxType(value) {
      const item = this.standards[value];
      this.config.cropBoxTypeData = item.data;
      let width = item.data.width;
      let height = item.data.height;
      if(item.data.unit === 'mm') {
        width = pxConvertor.mmToPx(width);
        height = pxConvertor.mmToPx(height);
      }
      this.config.width = width;
      this.config.height = height;
      this.setCropBoxData();
    },
    setCropBoxData() {
      // 获取原图尺寸
      let imgData = this.cropper.getImageData();
      if (this.config.width > imgData.naturalWidth || this.config.height > imgData.naturalHeight) {
        // 设置的裁剪框尺寸超过图片原尺寸
        // 对图片进行适当的拉伸
        // 弹窗提示
        if (!this.config.scale.isScaled) {
          this.$message({
            message: this.$t('tools.idPhotoEditor.scaleTip'),
            type: 'warning'
          });
        }
        const widthScale = this.config.width / imgData.naturalWidth;
        const heightScale = this.config.height / imgData.naturalHeight;
        const scale = widthScale > heightScale ? widthScale : heightScale;
        if (scale !== this.config.scale.value) {
          this.cropper.scale(scale);
          this.cropper.zoom(-scale);
          const containerData = this.cropper.getContainerData();
          const canvasData = this.cropper.getCanvasData();
          this.cropper.moveTo(((containerData.width - canvasData.width) / 2 ), ((containerData.height - canvasData.height) / 2 ));

          this.config.scale.value = scale;
        }
      
        this.config.scale.isScaled = true;
      } else {
        // 设置的裁剪框尺寸小于图片原尺寸
        // 重置编辑器
        this.cropper.reset();
        // 还原缩放设置
        this.config.scale.isScaled = false;
        this.config.scale.value = 1;
      }
      this.cropper.setData({
        width: this.config.width,
        height: this.config.height
      });
    },
    getCropBoxData() {
      // 获取裁剪框宽高
      let cropBoxData = this.cropper.getData();
      this.config.width = cropBoxData.width;
      this.config.height = cropBoxData.height;
    },
    changeSaveTypes(data) {
      let suffix = "png";
      if ("image/jpeg" === data) {
        suffix = "jpg";
      } else if ("image/gif" === data) {
        suffix = "gif";
      }

      this.config.saveType.suffix = suffix;
    },
    importImg() {
      document.getElementById("file").click();
    },
    resetEditor() {
      this.cropper.reset();
    },
    rotateImg(direction) {
      let degree = this.config.degree;
      if (direction === 'left') {
        degree = -degree;
      }
      this.cropper.rotate(degree);
    },
    cropAndSave() {
      this.cropper.getCroppedCanvas(
        this.config.saveType.type === "image/png" ? { imageSmoothingQuality: 'high' } : { fillColor: "#fff", imageSmoothingQuality: 'high' }
      ).toBlob(blob => {
        // 生成文件名
        const mode = this.config.cropBoxMode;
        let filename = this.data.name;
        if (filename.lastIndexOf(".") !== -1) {
          filename = filename.substring(0, filename.lastIndexOf("."));
        }
        if (mode === 0) {
          // 自定义模式
          filename += "_" + Math.round(this.cropWidth) + "x" + Math.round(this.cropHeight);
        } else if (mode === 1) {
          // 标准模式
          filename += "_" + this.config.cropBoxTypeData.label;
        }
        // 保存图片
        this.$message({
          message: this.$t('tools.idPhotoEditor.downloadTip'),
          type: 'success'
        });
        saveAs(blob, filename);
      }, this.config.saveType.type);
    }
  },
  mounted() {
    this.initCropper();
  }
};
</script>

<style scoped>
#id-photo-img {
  display: block;
  max-width: 100%;
  height: 30em;
}
.config-item {
  width: 85%;
}
.config-item.short {
  display: flex;
}
.config-item:not(.first) {
  margin-top: 20px;
}
.config-big-btn {
  font-size: 1.5em;
  border-radius: 30px;
  -moz-border-radius: 30px; /* Old Firefox */
}
.config-big-child-btn {
  font-size: 0.7em;
  width: 50%;
}
.unit-select {
  width: 80px;
}
</style>